<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Settings</h1>

    <div class="flex flex-wrap">
      <div class="w-full lg:w-1/2 px-2">
        <card>
            <card-list-item :href="route('areas.index')">
                Areas
            </card-list-item>
            <card-list-item :href="route('contact-types.index')">
                Contact Types
            </card-list-item>
            <card-list-item :href="route('custom-reports.index')">
                Custom Reports
            </card-list-item>
            <card-list-item :href="route('import-sources.index')">
                Import Sources
            </card-list-item>
        </card>
      </div>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Card from '@/Shared/Card/Card'
import CardListItem from '@/Shared/Card/CardListItem'
import { DateTime } from "luxon";

export default {
  metaInfo: { title: 'Settings' },
  layout: Layout,
  components: {
    Card,
    CardListItem,
  },
  methods: {
    dateFormat(iso) {
      return DateTime.fromISO(iso).toLocaleString(DateTime.DATETIME_FULL)
    },
  }
}
</script>
